
(function(){
  function initFAQ(root){
    if(!root || root.dataset.mfInit === 'true') return;
    root.dataset.mfInit = 'true';

    root.querySelectorAll('.mf-item').forEach(item=>{
      const btn=item.querySelector('.mf-question');
      const answer=item.querySelector('.mf-answer');
      if(!btn || !answer) return;
      btn.addEventListener('click',()=>{
        const open=item.classList.contains('is-open');
        item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(!open));
        answer.style.maxHeight=open ? null : answer.scrollHeight+'px';
      });
      if(item.classList.contains('is-open')){
        btn.setAttribute('aria-expanded','true');
        answer.style.maxHeight=answer.scrollHeight+'px';
      }else{
        btn.setAttribute('aria-expanded','false');
      }
    });

    const form=root.querySelector('.mf-search');
    const input=root.querySelector('.mf-search input');
    const noResults=root.querySelector('.mf-no-results');
    const doSearch=()=>{
      const q=(input?.value||'').trim().toLowerCase();
      let visible=0;
      root.querySelectorAll('.mf-item').forEach(item=>{
        const match=!q || item.textContent.toLowerCase().includes(q);
        item.style.display=match?'block':'none';
        if(match) visible++;
      });
      root.querySelectorAll('.mf-group').forEach(group=>{
        const any=[...group.querySelectorAll('.mf-item')].some(i=>i.style.display!=='none');
        group.style.display=any?'block':'none';
      });
      if(noResults) noResults.style.display=visible?'none':'block';
    };
    if(form) form.addEventListener('submit',e=>{e.preventDefault();doSearch();});
    if(input) input.addEventListener('input',doSearch);

    const links=[...root.querySelectorAll('.mf-side-nav a')];
    const groups=[...root.querySelectorAll('.mf-group')];
    if('IntersectionObserver' in window){
      const navObserver=new IntersectionObserver(entries=>{
        entries.forEach(entry=>{
          if(entry.isIntersecting){
            links.forEach(a=>a.classList.toggle('is-active',a.getAttribute('href')==='#'+entry.target.id));
          }
        });
      },{rootMargin:'-35% 0px -55% 0px'});
      groups.forEach(s=>navObserver.observe(s));

      const io=new IntersectionObserver(entries=>{
        entries.forEach(entry=>{
          if(entry.isIntersecting){
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },{threshold:.1});
      root.querySelectorAll('.mf-reveal').forEach(el=>io.observe(el));
    }else{
      root.querySelectorAll('.mf-reveal').forEach(el=>el.classList.add('is-visible'));
    }
  }

  document.addEventListener('DOMContentLoaded',()=>document.querySelectorAll('.mialica-faq-page').forEach(initFAQ));
  document.addEventListener('shopify:section:load',e=>{
    const r=e.target.querySelector('.mialica-faq-page') || (e.target.matches?.('.mialica-faq-page') ? e.target : null);
    if(r) initFAQ(r);
  });
})();
